import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import * as moment from 'jalali-moment';

@Injectable()
export class DateConverService {

  getEnglishDate(date: any): any{

    return moment(date, 'jYYYY-jMM-jDD').locale('en').format('YYYY-MM-DD');
    // if(language == 'en')
    // {
    //   return moment(date, 'YYYY/MM/DD').locale('fa').format('jYYYY/jMM/jDD');
    // }
    // if(language == 'fa'){
    //   return moment(date, 'jYYYY/jMM/jDD').locale('en').format('YYYY/MM/DD');
    // }
  }

  getPersianDate(date: any): any{

    return moment(date, 'YYYY-MM-DD').locale('fa').format('jYYYY-jMM-jDD');
    // if(language == 'en')
    // {
    //   return moment(date, 'YYYY/MM/DD').locale('fa').format('jYYYY/jMM/jDD');
    // }
    // if(language == 'fa'){
    //   return moment(date, 'jYYYY/jMM/jDD').locale('en').format('YYYY/MM/DD');
    // }
  }

  private handleError(error: Response | any) {
    return Promise.reject(error.message || error);
  }
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/shared/custom-service/DateConvert.service.ts